import React, { PropTypes, Component } from 'react'
import styles from './styles'
import TextCell from './dataCell/textCell'
import misc from 'utils/misc'

export default class DataRowHeader extends Component {
  static propTypes = {
    schemas: PropTypes.array.isRequired,
  };

  constructor (props, context) {
    super(props, context)
  }

  shouldComponentUpdate (nextProps) {
    return (misc.isObjectEqual(this.props, nextProps))
  }

  render () {
    return (
      <div className={styles.dataRowHeader} >
        {this.props.schemas.map(schema => {
          const cellProps = {}
          cellProps.key = `rowHeader ${schema.key}`
          cellProps.dataKey = schema.key
          cellProps.width = schema.width
          cellProps.text = schema.title
          return <TextCell {...cellProps} />
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataRowHeader.jsx